import ActionButton from './ActionButton.vue';

export default ActionButton;
